module.exports = __webpack_public_path__ + "img/facebook.022376f4.svg";